import {EventEmitter} from 'events';

class Event extends EventEmitter {}

export default new Event();
